<template>
<ItpBox
  alignItems="center"
  class="items-spacing w-100"
  v-if="loaded"
>
  <ItpBox
    direction="column"
  >
    <ItpText
      muted
      class="mb-0"
    >
      {{ resourceTitle }}
    </ItpText>
    <ItpText
      tag="h4"
      :text="resourceKey"
      class="mb-0"
    >
    </ItpText>
  </ItpBox>
  <UcInvoiceTypeBadge
    :value="invoice.invoice_type"
    :kind="invoice.invoice_kind"
    :advance="invoice.is_advance"
  >
  </UcInvoiceTypeBadge>
  <UcInvoiceStatusBadge
    :value="invoice.status"
  >
  </UcInvoiceStatusBadge>
  <UcInvoiceNumberingSelector
    :invoice="invoice"
    :value="invoice.meta.numbering"
    :options="invoice.meta.numbering_options"
    v-if="invoice.meta && invoice.meta.numbering"
    @reload="evh_1048678296148443_reload($event, {})"
  >
  </UcInvoiceNumberingSelector>
  <DIV
    v-if="invoice.tags && invoice.tags.length"
  >
    <span
      class="badge badge-secondary mx-1 shadow-none"
      v-for="tag in invoice.tags"
    >
      {{ tag }}
    </span>
  </DIV>
  <DIV
    :title="'Closed'|gettext"
    v-if="invoice.isReadOnly"
  >
    <ItpIcon
      :icon="$config.lockIcon"
    >
    </ItpIcon>
  </DIV>
  <DIV
    class="text-green-500"
    v-if="invoice.authority_transaction_id"
  >
    <DIV
      :title="invoice.authority_transaction_id"
    >
      <ItpIcon
        icon="fluent:cloud-sync-complete-16-regular"
      >
      </ItpIcon>
    </DIV>
    <DIV
      :title="JSON.stringify(invoice.authority_transaction_status)"
    >
      <ItpIcon
        icon="fa-question-circle"
      >
      </ItpIcon>
    </DIV>
  </DIV>
  <ItpBox
    direction="column"
    v-if="invoice.reference_invoice"
  >
    <ItpText
      muted
      class="mb-0"
    >
      {{ 'Reference invoice'|pgettext('Invoice') }}
    </ItpText>
    <UcInvoiceMiniCard
      :item="invoice.reference_invoice"
      no-icon
    >
    </UcInvoiceMiniCard>
  </ItpBox>
  <ItpBox
    direction="column"
    v-if="invoice.referencing_invoices && invoice.referencing_invoices.length"
  >
    <ItpText
      muted
      class="mb-0"
    >
      {{ 'Referencing invoices'|pgettext('Invoice') }}
    </ItpText>
    <ItpBox>
      <UcInvoiceMiniCard
        :key="obj.id"
        :item="obj"
        no-icon
        class="mr-2"
        v-for="obj in invoice.referencing_invoices"
      >
      </UcInvoiceMiniCard>
    </ItpBox>
  </ItpBox>
  <Icon
    :icon="'flagpack:' + invoice.language"
    :title="'Invoice Language'|pgettext('Invoice')"
    v-if="!invoice.isNew"
  >
  </Icon>
  <DIV
    class="btn-toolbar ml-auto flex-nowrap"
  >
    <BtnIssueInvoice
      :invoice="invoice"
      class="ml-auto mr-2"
      v-if="invoice.meta && invoice.meta.issuance_status.status == 'not_started'"
      @success="evh_6639903447389385_success($event, {})"
    >
    </BtnIssueInvoice>
    <BtnSyncInvoice
      :invoice="invoice"
      class="ml-auto mr-2"
      v-if="invoice.meta && invoice.meta.billing_service_status.status == 'not_started'"
      @success="evh_3803044933457651_success($event, {})"
    >
    </BtnSyncInvoice>
    <BtnReportInvoiceData
      :resource="invoice"
      class="ml-auto mr-2"
      v-if="invoice.meta && (invoice.meta.data_reporting_status.status == 'not_started' || invoice.meta.data_reporting_status.status == 'error')"
      @success="evh_4764767232201234_success($event, {})"
    >
    </BtnReportInvoiceData>
    <BtnSyncResource
      :resource="invoice"
      target="irent"
      confirmMessage="A számlát csak egyszer lehet felölteni a régi rendszerbe,
feltöltés után a számlát már nem lehet módosítani."
      class="ml-auto mr-2"
      v-if="invoice.meta && invoice.meta.sync_to_external_system_status.status == 'not_started'"
      @success="evh_7992484462910578_success($event, {})"
    >
    </BtnSyncResource>
    <ItpButton
      :icon="$config.editIcon"
      :tooltip="'Edit'|gettext"
      variant="light"
      class="ml-auto mr-2"
      v-if="!invoice.isNew && !invoice.isReadOnly"
      @click.prevent.stop="evh_7716964648426498_clickPreventStop($event, {})"
    >
    </ItpButton>
    <ItpButton
      icon="fa-sync-alt"
      :tooltip="'Reload'|gettext"
      :spinning="actions.reload.isRunning"
      variant="light"
      class="ml-auto mr-2"
      v-if="!invoice.isNew"
      @click.prevent.stop="evh_2940653511262489_clickPreventStop($event, {})"
    >
    </ItpButton>
    <UcInvoiceViewDocumentDropdown
      :invoice="invoice"
      class="ml-auto mr-2"
      @click.prevent.stop="evh_689536327456849_clickPreventStop($event, {})"
    >
    </UcInvoiceViewDocumentDropdown>
    <ItpButton
      variant="light"
      icon="icon-park-outline:preview-open"
      :href="invoice.preview_url"
      :tooltip="'Open preview'|pgettext('Invoice')"
      target="_blank"
      use-auth
      show-spinner
      class="ml-auto mr-2"
      v-if="invoice.preview_url"
    >
    </ItpButton>
    <ItpButton
      variant="light"
      icon="icon-park-outline:log"
      :tooltip="'Show log messages'|pgettext('Invoice')"
      class="ml-auto mr-2"
      v-if="invoice.log_messages"
      @click.prevent.stop="evh_8254501898831426_clickPreventStop($event, {})"
    >
    </ItpButton>
    <b-dropdown
      right
      variant="light"
      no-caret
      class="border"
      v-if="!invoice.isNew"
    >
      <ItpIcon
        fa="bars"
        class="mx-1"
        slot="button-content"
      >
      </ItpIcon>
      <ItpButton
        dropdown-item
        :text="'Register invoice'|pgettext('Invoice')"
        :tooltip="'Add this invoice to the invoice register'|pgettext('Invoice')"
        variant="default"
        v-if="invoiceIsRegistrable"
        @click="evh_951936257455896_click($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Copy'|pgettext('BtnCopyResource')"
        :tooltip="'Create new invoice from this one'|pgettext('Invoice')"
        variant="default"
        @click="evh_7010716094810887_click($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Create pass-through'|pgettext('Invoice')"
        :tooltip="messages.createPassThroughTooltip"
        variant="default"
        :disabled="!invoicePassThroughIsEnabled"
        v-if="!invoice.isNew"
        @click="evh_4971252216919813_click($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Create advance'|pgettext('Invoice')"
        :tooltip="messages.createAdvanceInvoiceTooltip"
        variant="default"
        :disabled="!canCreateAdvanceInvoice"
        v-if="!invoice.isNew"
        @click="evh_3581444176199717_click($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Create final'|pgettext('Invoice')"
        :tooltip="messages.createFinalInvoiceTooltip"
        variant="default"
        :disabled="!canCreateFinalInvoice"
        v-if="!invoice.isNew"
        @click="evh_6391442819935878_click($event, {})"
      >
      </ItpButton>
      <hr>
      </hr>
      <ItpButton
        dropdown-item
        :text="'Create storno'|pgettext('Invoice')"
        :tooltip="createStornoTooltip"
        variant="default"
        :disabled="!invoiceIsReversible"
        v-if="!invoice.isNew"
        @click="evh_2988515090283815_click($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        variant="default"
        :text="'Create corrector'|pgettext('Invoice')"
        :tooltip="createCorrectorTooltip"
        :disabled="!invoiceIsModifiable"
        v-if="!invoice.isNew"
        @click="evh_3478991899028773_click($event, {})"
      >
      </ItpButton>
      <BtnLockResource
        no-icon
        dropdown-item
        :resource="invoice"
        :tooltip="'Lock invoice'|pgettext('Invoice')"
        v-if="!invoice.isNew && !invoice.isReadOnly"
        @success="evh_8376575288437415_success($event, {})"
      >
      </BtnLockResource>
      <BtnDeleteResource
        no-icon
        dropdown-item
        :resource="invoice"
        :tooltip="'Delete invoice'|pgettext('Invoice')"
        v-if="!invoice.isNew && !invoice.isReadOnly"
        @success="evh_3958027742391354_success($event, {})"
      >
      </BtnDeleteResource>
      <hr>
      </hr>
      <ItpButton
        dropdown-item
        :text="'History'|pgettext('BtnResourceHistory')"
        :tooltip="'Invoice history'|pgettext('Invoice')"
        variant="default"
        @click.prevent.stop="evh_8122162285230843_clickPreventStop($event, {})"
      >
      </ItpButton>
    </b-dropdown>
  </DIV>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcInvoiceHeader extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  invoice!: object;

  @Watch('invoice')
  onInvoice(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoice")
  }

  @Prop({
    type: String,
    default: function() {
      return this.$fn.randomElementId()
    },
  })
  formId!: string;

  @Watch('formId')
  onForm_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("formId")
  }

  @Prop({
    type: String,
  })
  invoiceNumber!: string;

  @Watch('invoiceNumber')
  onInvoice_number(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoiceNumber")
  }

  @Prop({
    required: true,
    type: Object,
  })
  formContext!: object;

  @Watch('formContext')
  onForm_context(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("formContext")
  }

  messages!: any;
  ux!: any;
  dataMembers = ['messages', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          newTransaction: this.$fn.pgettext("Invoice", "New Invoice"),
          invoiceKind: {
            incoming: this.$fn.pgettext("InvoiceKind", "Incoming Invoice"),
            outgoing: this.$fn.pgettext("InvoiceKind", "Outgoing Invoice"),
          }
          ,
          createCorrectorTooltip: this.$fn.pgettext("Invoice", "Create corrector invoice"),
          createStornoTooltip: this.$fn.pgettext("Invoice", "Create storno invoice"),
          createPassThroughTooltip: this.$fn.pgettext("Invoice|Tooltip", "Rebilling the line items to a designated client."),
          createAdvanceInvoiceTooltip: this.$fn.pgettext("Invoice|Tooltip", "Create advance invoice from a Pro Forma invoice."),
          createFinalInvoiceTooltip: this.$fn.pgettext("Invoice|Tooltip", "Create final invoice from a Pro Forma or advance invoice."),
        }
        ,
        ux: null,
      },
    }
  }

  get resourceTitle() {
    if (this.loaded) {

      return this.messages.invoiceKind[this.invoice.invoice_kind]
    }
    return null;
  }

  get resourceKey() {
    if (this.loaded) {

      return this.invoiceNumber || (this.invoice.isNew ? this.messages.newTransaction : this.invoice.invoice_number)
    }
    return null;
  }

  get createCorrectorTooltip() {
    if (this.loaded) {

      return _.get(this.invoice, 'meta.modifiable.message') || this.messages.createCorrectorTooltip
    }
    return null;
  }

  get createStornoTooltip() {
    if (this.loaded) {

      return _.get(this.invoice, 'meta.reversible.message') || this.messages.createStornoTooltip
    }
    return null;
  }

  get invoiceIsReversible() {
    if (this.loaded) {

      return _.get(this.invoice, 'meta.reversible.result')
    }
    return null;
  }

  get invoiceIsModifiable() {
    if (this.loaded) {

      return _.get(this.invoice, 'meta.modifiable.result')
    }
    return null;
  }

  get invoiceIsRegistrable() {
    if (this.loaded) {

      return _.get(this.invoice, 'meta.registrable.result')
    }
    return null;
  }

  get invoicePassThroughIsEnabled() {
    if (this.loaded) {

      return _.get(this.invoice, 'meta.pass_through_enabled') === true ||
        _.get(this.invoice, 'meta.pass_through_enabled.result')
    }
    return null;
  }

  get canCreateAdvanceInvoice() {
    if (this.loaded) {

      return _.get(this.invoice, 'meta.can_create_advance_invoice') === true
    }
    return null;
  }

  get canCreateFinalInvoice() {
    if (this.loaded) {

      return _.get(this.invoice, 'meta.can_create_final_invoice') === true
    }
    return null;
  }

  async act_1048678296148443_emit_7546_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_1048678296148443_emit_7546, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_1048678296148443_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1048678296148443_reload.executeFromDOM(this, event, scope);
  }

  async act_6639903447389385_emit_7548_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_6639903447389385_emit_7548, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_6639903447389385_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6639903447389385_success.executeFromDOM(this, event, scope);
  }

  async act_3803044933457651_emit_7550_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_3803044933457651_emit_7550, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_3803044933457651_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3803044933457651_success.executeFromDOM(this, event, scope);
  }

  async act_4764767232201234_emit_7552_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_4764767232201234_emit_7552, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_4764767232201234_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4764767232201234_success.executeFromDOM(this, event, scope);
  }

  async act_7992484462910578_emit_7554_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_7992484462910578_emit_7554, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_7992484462910578_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7992484462910578_success.executeFromDOM(this, event, scope);
  }

  async act_7716964648426498_emit_7558_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_7716964648426498_emit_7558, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_7716964648426498_close_7557_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_7716964648426498_close_7557, alias=undefined
    return $event.data.modalResult.ok
  }

  async act_7716964648426498_showModal_7556_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_7716964648426498_showModal_7556, alias=undefined
    return {
      name: "InvoiceEditor",
      props: {
        invoice: _.cloneDeep(this.invoice),
      }
      ,
    }
  }

  async evh_7716964648426498_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7716964648426498_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_2940653511262489_emit_7560_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_2940653511262489_emit_7560, alias=reload
    return {
      event: "reload",
    }
  }

  async evh_2940653511262489_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2940653511262489_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_689536327456849_emit_7562_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_689536327456849_emit_7562, alias=reload
    return {
      event: "reload",
    }
  }

  async evh_689536327456849_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_689536327456849_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_8254501898831426_showModal_7564_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8254501898831426_showModal_7564, alias=undefined
    return {
      name: "InvoiceLogMessageViewer",
      props: {
        invoiceId: this.invoice.id,
      }
      ,
    }
  }

  async evh_8254501898831426_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8254501898831426_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_951936257455896_emit_7568_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_951936257455896_emit_7568, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_951936257455896_close_7567_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_951936257455896_close_7567, alias=undefined
    return $event.data.modalResult.ok
  }

  async act_951936257455896_showModal_7566_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_951936257455896_showModal_7566, alias=registerInvoice
    return {
      name: "RegisterEntry",
      props: {
        invoice: this.invoice,
      }
      ,
    }
  }

  async evh_951936257455896_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_951936257455896_click.executeFromDOM(this, event, scope);
  }

  async act_7010716094810887_emit_7572_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_7010716094810887_emit_7572, alias=undefined
    return {
      event: "created",
      value: $event.data.response.data,
    }
  }

  async act_7010716094810887_request_7570_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_7010716094810887_request_7570, alias=createInvoicecopy
    return {
      operation: "create_invoice",
      data: { invoice_id: this.invoice.id, invoice_type: 'copy' },
    }
  }

  async evh_7010716094810887_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7010716094810887_click.executeFromDOM(this, event, scope);
  }

  async act_4971252216919813_emit_7576_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_4971252216919813_emit_7576, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_4971252216919813_close_7575_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_4971252216919813_close_7575, alias=undefined
    return $event.data.modalResult.ok
  }

  async act_4971252216919813_showModal_7574_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_4971252216919813_showModal_7574, alias=createPassThroughInvoice
    return {
      name: "CreatePassThroughInvoice",
      props: {
        invoice: this.invoice,
      }
      ,
    }
  }

  async evh_4971252216919813_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4971252216919813_click.executeFromDOM(this, event, scope);
  }

  async act_3581444176199717_emit_7580_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_3581444176199717_emit_7580, alias=undefined
    return {
      event: "created",
      value: $event.data.response.data,
    }
  }

  async act_3581444176199717_request_7578_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_3581444176199717_request_7578, alias=createAdvanceInvoice
    return {
      operation: "create_invoice",
      data: { invoice_id: this.invoice.id, invoice_type: 'advance' },
    }
  }

  async evh_3581444176199717_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3581444176199717_click.executeFromDOM(this, event, scope);
  }

  async act_6391442819935878_emit_7584_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_6391442819935878_emit_7584, alias=undefined
    return {
      event: "created",
      value: $event.data.response.data,
    }
  }

  async act_6391442819935878_request_7582_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_6391442819935878_request_7582, alias=createFinalInvoice
    return {
      operation: "create_invoice",
      data: { invoice_id: this.invoice.id, invoice_type: 'final' },
    }
  }

  async evh_6391442819935878_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6391442819935878_click.executeFromDOM(this, event, scope);
  }

  async act_2988515090283815_emit_7588_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_2988515090283815_emit_7588, alias=undefined
    return {
      event: "created",
      value: $event.data.response.data,
    }
  }

  async act_2988515090283815_request_7586_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_2988515090283815_request_7586, alias=createStornoInvoice
    return {
      operation: "create_invoice",
      data: { invoice_id: this.invoice.id, invoice_type: 'storno' },
    }
  }

  async evh_2988515090283815_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2988515090283815_click.executeFromDOM(this, event, scope);
  }

  async act_3478991899028773_emit_7592_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_3478991899028773_emit_7592, alias=undefined
    return {
      event: "created",
      value: $event.data.response.data,
    }
  }

  async act_3478991899028773_request_7590_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_3478991899028773_request_7590, alias=createCorrectorIvoice
    return {
      operation: "create_invoice",
      data: {
        invoice_id: this.invoice.id,
        invoice_type: 'correction',
        invoice_lines: _.map(this.formContext.selectedInvoiceLines, p => p.id).join(',')
      },
    }
  }

  async evh_3478991899028773_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3478991899028773_click.executeFromDOM(this, event, scope);
  }

  async act_8376575288437415_emit_7594_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_8376575288437415_emit_7594, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_8376575288437415_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8376575288437415_success.executeFromDOM(this, event, scope);
  }

  async act_3958027742391354_emit_7596_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_3958027742391354_emit_7596, alias=undefined
    return {
      event: "deleted",
    }
  }

  async evh_3958027742391354_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3958027742391354_success.executeFromDOM(this, event, scope);
  }

  async act_8122162285230843_showModal_7598_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8122162285230843_showModal_7598, alias=undefined
    return {
      name: "entityEvents",
      props: {
        entityId: this.invoice.id,
      }
      ,
    }
  }

  async evh_8122162285230843_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8122162285230843_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_1048678296148443_emit_7546: actions.EmitAction;
    evh_1048678296148443_reload_7545: actions.EventHandlerImpl;
    evh_1048678296148443_reload: actions.EventHandlerGroup;
    act_6639903447389385_emit_7548: actions.EmitAction;
    evh_6639903447389385_success_7547: actions.EventHandlerImpl;
    evh_6639903447389385_success: actions.EventHandlerGroup;
    act_3803044933457651_emit_7550: actions.EmitAction;
    evh_3803044933457651_success_7549: actions.EventHandlerImpl;
    evh_3803044933457651_success: actions.EventHandlerGroup;
    act_4764767232201234_emit_7552: actions.EmitAction;
    evh_4764767232201234_success_7551: actions.EventHandlerImpl;
    evh_4764767232201234_success: actions.EventHandlerGroup;
    act_7992484462910578_emit_7554: actions.EmitAction;
    evh_7992484462910578_success_7553: actions.EventHandlerImpl;
    evh_7992484462910578_success: actions.EventHandlerGroup;
    act_7716964648426498_emit_7558: actions.EmitAction;
    evh_7716964648426498_close_7557: actions.EventHandlerImpl;
    act_7716964648426498_showModal_7556: actions.ShowModalAction;
    evh_7716964648426498_clickPreventStop_7555: actions.EventHandlerImpl;
    evh_7716964648426498_clickPreventStop: actions.EventHandlerGroup;
    act_2940653511262489_emit_7560: actions.EmitAction;
    evh_2940653511262489_clickPreventStop_7559: actions.EventHandlerImpl;
    evh_2940653511262489_clickPreventStop: actions.EventHandlerGroup;
    act_689536327456849_emit_7562: actions.EmitAction;
    evh_689536327456849_clickPreventStop_7561: actions.EventHandlerImpl;
    evh_689536327456849_clickPreventStop: actions.EventHandlerGroup;
    act_8254501898831426_showModal_7564: actions.ShowModalAction;
    evh_8254501898831426_clickPreventStop_7563: actions.EventHandlerImpl;
    evh_8254501898831426_clickPreventStop: actions.EventHandlerGroup;
    act_951936257455896_emit_7568: actions.EmitAction;
    evh_951936257455896_close_7567: actions.EventHandlerImpl;
    act_951936257455896_showModal_7566: actions.ShowModalAction;
    evh_951936257455896_click_7565: actions.EventHandlerImpl;
    evh_951936257455896_click: actions.EventHandlerGroup;
    act_7010716094810887_emit_7572: actions.EmitAction;
    evh_7010716094810887_success_7571: actions.EventHandlerImpl;
    act_7010716094810887_request_7570: actions.RequestAction;
    evh_7010716094810887_click_7569: actions.EventHandlerImpl;
    evh_7010716094810887_click: actions.EventHandlerGroup;
    act_4971252216919813_emit_7576: actions.EmitAction;
    evh_4971252216919813_close_7575: actions.EventHandlerImpl;
    act_4971252216919813_showModal_7574: actions.ShowModalAction;
    evh_4971252216919813_click_7573: actions.EventHandlerImpl;
    evh_4971252216919813_click: actions.EventHandlerGroup;
    act_3581444176199717_emit_7580: actions.EmitAction;
    evh_3581444176199717_success_7579: actions.EventHandlerImpl;
    act_3581444176199717_request_7578: actions.RequestAction;
    evh_3581444176199717_click_7577: actions.EventHandlerImpl;
    evh_3581444176199717_click: actions.EventHandlerGroup;
    act_6391442819935878_emit_7584: actions.EmitAction;
    evh_6391442819935878_success_7583: actions.EventHandlerImpl;
    act_6391442819935878_request_7582: actions.RequestAction;
    evh_6391442819935878_click_7581: actions.EventHandlerImpl;
    evh_6391442819935878_click: actions.EventHandlerGroup;
    act_2988515090283815_emit_7588: actions.EmitAction;
    evh_2988515090283815_success_7587: actions.EventHandlerImpl;
    act_2988515090283815_request_7586: actions.RequestAction;
    evh_2988515090283815_click_7585: actions.EventHandlerImpl;
    evh_2988515090283815_click: actions.EventHandlerGroup;
    act_3478991899028773_emit_7592: actions.EmitAction;
    evh_3478991899028773_success_7591: actions.EventHandlerImpl;
    act_3478991899028773_request_7590: actions.RequestAction;
    evh_3478991899028773_click_7589: actions.EventHandlerImpl;
    evh_3478991899028773_click: actions.EventHandlerGroup;
    act_8376575288437415_emit_7594: actions.EmitAction;
    evh_8376575288437415_success_7593: actions.EventHandlerImpl;
    evh_8376575288437415_success: actions.EventHandlerGroup;
    act_3958027742391354_emit_7596: actions.EmitAction;
    evh_3958027742391354_success_7595: actions.EventHandlerImpl;
    evh_3958027742391354_success: actions.EventHandlerGroup;
    act_8122162285230843_showModal_7598: actions.ShowModalAction;
    evh_8122162285230843_clickPreventStop_7597: actions.EventHandlerImpl;
    evh_8122162285230843_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_1048678296148443_emit_7546 = new actions.EmitAction(
      {
        actionArgs: this.act_1048678296148443_emit_7546_getActionArgs,
        events: [],
      }
    );
    const evh_1048678296148443_reload_7545 = new actions.EventHandlerImpl(
      {
        action: act_1048678296148443_emit_7546,
        event: "reload",
        displayName: "emit",
      }
    );
    const evh_1048678296148443_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_1048678296148443_reload_7545],
      }
    );
    const act_6639903447389385_emit_7548 = new actions.EmitAction(
      {
        actionArgs: this.act_6639903447389385_emit_7548_getActionArgs,
        events: [],
      }
    );
    const evh_6639903447389385_success_7547 = new actions.EventHandlerImpl(
      {
        action: act_6639903447389385_emit_7548,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_6639903447389385_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_6639903447389385_success_7547],
      }
    );
    const act_3803044933457651_emit_7550 = new actions.EmitAction(
      {
        actionArgs: this.act_3803044933457651_emit_7550_getActionArgs,
        events: [],
      }
    );
    const evh_3803044933457651_success_7549 = new actions.EventHandlerImpl(
      {
        action: act_3803044933457651_emit_7550,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_3803044933457651_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_3803044933457651_success_7549],
      }
    );
    const act_4764767232201234_emit_7552 = new actions.EmitAction(
      {
        actionArgs: this.act_4764767232201234_emit_7552_getActionArgs,
        events: [],
      }
    );
    const evh_4764767232201234_success_7551 = new actions.EventHandlerImpl(
      {
        action: act_4764767232201234_emit_7552,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_4764767232201234_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_4764767232201234_success_7551],
      }
    );
    const act_7992484462910578_emit_7554 = new actions.EmitAction(
      {
        actionArgs: this.act_7992484462910578_emit_7554_getActionArgs,
        events: [],
      }
    );
    const evh_7992484462910578_success_7553 = new actions.EventHandlerImpl(
      {
        action: act_7992484462910578_emit_7554,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_7992484462910578_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_7992484462910578_success_7553],
      }
    );
    const act_7716964648426498_emit_7558 = new actions.EmitAction(
      {
        actionArgs: this.act_7716964648426498_emit_7558_getActionArgs,
        events: [],
      }
    );
    const evh_7716964648426498_close_7557 = new actions.EventHandlerImpl(
      {
        action: act_7716964648426498_emit_7558,
        event: "close",
        when: this.evh_7716964648426498_close_7557_getWhen,
        displayName: "emit",
      }
    );
    const act_7716964648426498_showModal_7556 = new actions.ShowModalAction(
      {
        actionArgs: this.act_7716964648426498_showModal_7556_getActionArgs,
        events: [evh_7716964648426498_close_7557],
      }
    );
    const evh_7716964648426498_clickPreventStop_7555 = new actions.EventHandlerImpl(
      {
        action: act_7716964648426498_showModal_7556,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_7716964648426498_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_7716964648426498_clickPreventStop_7555],
      }
    );
    const act_2940653511262489_emit_7560 = new actions.EmitAction(
      {
        actionArgs: this.act_2940653511262489_emit_7560_getActionArgs,
        displayName: "reload",
        events: [],
      }
    );
    const evh_2940653511262489_clickPreventStop_7559 = new actions.EventHandlerImpl(
      {
        action: act_2940653511262489_emit_7560,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_2940653511262489_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2940653511262489_clickPreventStop_7559],
      }
    );
    const act_689536327456849_emit_7562 = new actions.EmitAction(
      {
        actionArgs: this.act_689536327456849_emit_7562_getActionArgs,
        displayName: "reload",
        events: [],
      }
    );
    const evh_689536327456849_clickPreventStop_7561 = new actions.EventHandlerImpl(
      {
        action: act_689536327456849_emit_7562,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_689536327456849_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_689536327456849_clickPreventStop_7561],
      }
    );
    const act_8254501898831426_showModal_7564 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8254501898831426_showModal_7564_getActionArgs,
        events: [],
      }
    );
    const evh_8254501898831426_clickPreventStop_7563 = new actions.EventHandlerImpl(
      {
        action: act_8254501898831426_showModal_7564,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_8254501898831426_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8254501898831426_clickPreventStop_7563],
      }
    );
    const act_951936257455896_emit_7568 = new actions.EmitAction(
      {
        actionArgs: this.act_951936257455896_emit_7568_getActionArgs,
        events: [],
      }
    );
    const evh_951936257455896_close_7567 = new actions.EventHandlerImpl(
      {
        action: act_951936257455896_emit_7568,
        event: "close",
        when: this.evh_951936257455896_close_7567_getWhen,
        displayName: "emit",
      }
    );
    const act_951936257455896_showModal_7566 = new actions.ShowModalAction(
      {
        actionArgs: this.act_951936257455896_showModal_7566_getActionArgs,
        displayName: "registerInvoice",
        events: [evh_951936257455896_close_7567],
      }
    );
    const evh_951936257455896_click_7565 = new actions.EventHandlerImpl(
      {
        action: act_951936257455896_showModal_7566,
        event: "click",
        displayName: "registerInvoice",
      }
    );
    const evh_951936257455896_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_951936257455896_click_7565],
      }
    );
    const act_7010716094810887_emit_7572 = new actions.EmitAction(
      {
        actionArgs: this.act_7010716094810887_emit_7572_getActionArgs,
        events: [],
      }
    );
    const evh_7010716094810887_success_7571 = new actions.EventHandlerImpl(
      {
        action: act_7010716094810887_emit_7572,
        event: "success",
        displayName: "emit",
      }
    );
    const act_7010716094810887_request_7570 = new actions.RequestAction(
      {
        actionArgs: this.act_7010716094810887_request_7570_getActionArgs,
        displayName: "createInvoicecopy",
        events: [evh_7010716094810887_success_7571],
      }
    );
    const evh_7010716094810887_click_7569 = new actions.EventHandlerImpl(
      {
        action: act_7010716094810887_request_7570,
        event: "click",
        displayName: "createInvoicecopy",
      }
    );
    const evh_7010716094810887_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_7010716094810887_click_7569],
      }
    );
    const act_4971252216919813_emit_7576 = new actions.EmitAction(
      {
        actionArgs: this.act_4971252216919813_emit_7576_getActionArgs,
        events: [],
      }
    );
    const evh_4971252216919813_close_7575 = new actions.EventHandlerImpl(
      {
        action: act_4971252216919813_emit_7576,
        event: "close",
        when: this.evh_4971252216919813_close_7575_getWhen,
        displayName: "emit",
      }
    );
    const act_4971252216919813_showModal_7574 = new actions.ShowModalAction(
      {
        actionArgs: this.act_4971252216919813_showModal_7574_getActionArgs,
        displayName: "createPassThroughInvoice",
        events: [evh_4971252216919813_close_7575],
      }
    );
    const evh_4971252216919813_click_7573 = new actions.EventHandlerImpl(
      {
        action: act_4971252216919813_showModal_7574,
        event: "click",
        displayName: "createPassThroughInvoice",
      }
    );
    const evh_4971252216919813_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_4971252216919813_click_7573],
      }
    );
    const act_3581444176199717_emit_7580 = new actions.EmitAction(
      {
        actionArgs: this.act_3581444176199717_emit_7580_getActionArgs,
        events: [],
      }
    );
    const evh_3581444176199717_success_7579 = new actions.EventHandlerImpl(
      {
        action: act_3581444176199717_emit_7580,
        event: "success",
        displayName: "emit",
      }
    );
    const act_3581444176199717_request_7578 = new actions.RequestAction(
      {
        actionArgs: this.act_3581444176199717_request_7578_getActionArgs,
        displayName: "createAdvanceInvoice",
        events: [evh_3581444176199717_success_7579],
      }
    );
    const evh_3581444176199717_click_7577 = new actions.EventHandlerImpl(
      {
        action: act_3581444176199717_request_7578,
        event: "click",
        displayName: "createAdvanceInvoice",
      }
    );
    const evh_3581444176199717_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_3581444176199717_click_7577],
      }
    );
    const act_6391442819935878_emit_7584 = new actions.EmitAction(
      {
        actionArgs: this.act_6391442819935878_emit_7584_getActionArgs,
        events: [],
      }
    );
    const evh_6391442819935878_success_7583 = new actions.EventHandlerImpl(
      {
        action: act_6391442819935878_emit_7584,
        event: "success",
        displayName: "emit",
      }
    );
    const act_6391442819935878_request_7582 = new actions.RequestAction(
      {
        actionArgs: this.act_6391442819935878_request_7582_getActionArgs,
        displayName: "createFinalInvoice",
        events: [evh_6391442819935878_success_7583],
      }
    );
    const evh_6391442819935878_click_7581 = new actions.EventHandlerImpl(
      {
        action: act_6391442819935878_request_7582,
        event: "click",
        displayName: "createFinalInvoice",
      }
    );
    const evh_6391442819935878_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_6391442819935878_click_7581],
      }
    );
    const act_2988515090283815_emit_7588 = new actions.EmitAction(
      {
        actionArgs: this.act_2988515090283815_emit_7588_getActionArgs,
        events: [],
      }
    );
    const evh_2988515090283815_success_7587 = new actions.EventHandlerImpl(
      {
        action: act_2988515090283815_emit_7588,
        event: "success",
        displayName: "emit",
      }
    );
    const act_2988515090283815_request_7586 = new actions.RequestAction(
      {
        actionArgs: this.act_2988515090283815_request_7586_getActionArgs,
        displayName: "createStornoInvoice",
        events: [evh_2988515090283815_success_7587],
      }
    );
    const evh_2988515090283815_click_7585 = new actions.EventHandlerImpl(
      {
        action: act_2988515090283815_request_7586,
        event: "click",
        displayName: "createStornoInvoice",
      }
    );
    const evh_2988515090283815_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_2988515090283815_click_7585],
      }
    );
    const act_3478991899028773_emit_7592 = new actions.EmitAction(
      {
        actionArgs: this.act_3478991899028773_emit_7592_getActionArgs,
        events: [],
      }
    );
    const evh_3478991899028773_success_7591 = new actions.EventHandlerImpl(
      {
        action: act_3478991899028773_emit_7592,
        event: "success",
        displayName: "emit",
      }
    );
    const act_3478991899028773_request_7590 = new actions.RequestAction(
      {
        actionArgs: this.act_3478991899028773_request_7590_getActionArgs,
        displayName: "createCorrectorIvoice",
        events: [evh_3478991899028773_success_7591],
      }
    );
    const evh_3478991899028773_click_7589 = new actions.EventHandlerImpl(
      {
        action: act_3478991899028773_request_7590,
        event: "click",
        displayName: "createCorrectorIvoice",
      }
    );
    const evh_3478991899028773_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_3478991899028773_click_7589],
      }
    );
    const act_8376575288437415_emit_7594 = new actions.EmitAction(
      {
        actionArgs: this.act_8376575288437415_emit_7594_getActionArgs,
        events: [],
      }
    );
    const evh_8376575288437415_success_7593 = new actions.EventHandlerImpl(
      {
        action: act_8376575288437415_emit_7594,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_8376575288437415_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_8376575288437415_success_7593],
      }
    );
    const act_3958027742391354_emit_7596 = new actions.EmitAction(
      {
        actionArgs: this.act_3958027742391354_emit_7596_getActionArgs,
        events: [],
      }
    );
    const evh_3958027742391354_success_7595 = new actions.EventHandlerImpl(
      {
        action: act_3958027742391354_emit_7596,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_3958027742391354_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_3958027742391354_success_7595],
      }
    );
    const act_8122162285230843_showModal_7598 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8122162285230843_showModal_7598_getActionArgs,
        events: [],
      }
    );
    const evh_8122162285230843_clickPreventStop_7597 = new actions.EventHandlerImpl(
      {
        action: act_8122162285230843_showModal_7598,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_8122162285230843_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8122162285230843_clickPreventStop_7597],
      }
    );
    return {
      act_1048678296148443_emit_7546,
      evh_1048678296148443_reload_7545,
      evh_1048678296148443_reload,
      act_6639903447389385_emit_7548,
      evh_6639903447389385_success_7547,
      evh_6639903447389385_success,
      act_3803044933457651_emit_7550,
      evh_3803044933457651_success_7549,
      evh_3803044933457651_success,
      act_4764767232201234_emit_7552,
      evh_4764767232201234_success_7551,
      evh_4764767232201234_success,
      act_7992484462910578_emit_7554,
      evh_7992484462910578_success_7553,
      evh_7992484462910578_success,
      act_7716964648426498_emit_7558,
      evh_7716964648426498_close_7557,
      act_7716964648426498_showModal_7556,
      evh_7716964648426498_clickPreventStop_7555,
      evh_7716964648426498_clickPreventStop,
      act_2940653511262489_emit_7560,
      evh_2940653511262489_clickPreventStop_7559,
      evh_2940653511262489_clickPreventStop,
      act_689536327456849_emit_7562,
      evh_689536327456849_clickPreventStop_7561,
      evh_689536327456849_clickPreventStop,
      act_8254501898831426_showModal_7564,
      evh_8254501898831426_clickPreventStop_7563,
      evh_8254501898831426_clickPreventStop,
      act_951936257455896_emit_7568,
      evh_951936257455896_close_7567,
      act_951936257455896_showModal_7566,
      evh_951936257455896_click_7565,
      evh_951936257455896_click,
      act_7010716094810887_emit_7572,
      evh_7010716094810887_success_7571,
      act_7010716094810887_request_7570,
      evh_7010716094810887_click_7569,
      evh_7010716094810887_click,
      act_4971252216919813_emit_7576,
      evh_4971252216919813_close_7575,
      act_4971252216919813_showModal_7574,
      evh_4971252216919813_click_7573,
      evh_4971252216919813_click,
      act_3581444176199717_emit_7580,
      evh_3581444176199717_success_7579,
      act_3581444176199717_request_7578,
      evh_3581444176199717_click_7577,
      evh_3581444176199717_click,
      act_6391442819935878_emit_7584,
      evh_6391442819935878_success_7583,
      act_6391442819935878_request_7582,
      evh_6391442819935878_click_7581,
      evh_6391442819935878_click,
      act_2988515090283815_emit_7588,
      evh_2988515090283815_success_7587,
      act_2988515090283815_request_7586,
      evh_2988515090283815_click_7585,
      evh_2988515090283815_click,
      act_3478991899028773_emit_7592,
      evh_3478991899028773_success_7591,
      act_3478991899028773_request_7590,
      evh_3478991899028773_click_7589,
      evh_3478991899028773_click,
      act_8376575288437415_emit_7594,
      evh_8376575288437415_success_7593,
      evh_8376575288437415_success,
      act_3958027742391354_emit_7596,
      evh_3958027742391354_success_7595,
      evh_3958027742391354_success,
      act_8122162285230843_showModal_7598,
      evh_8122162285230843_clickPreventStop_7597,
      evh_8122162285230843_clickPreventStop,
      reload: act_689536327456849_emit_7562,
      registerInvoice: act_951936257455896_showModal_7566,
      createInvoicecopy: act_7010716094810887_request_7570,
      createPassThroughInvoice: act_4971252216919813_showModal_7574,
      createAdvanceInvoice: act_3581444176199717_request_7578,
      createFinalInvoice: act_6391442819935878_request_7582,
      createStornoInvoice: act_2988515090283815_request_7586,
      createCorrectorIvoice: act_3478991899028773_request_7590,
    }
  }
}

Vue.component("UcInvoiceHeader", UcInvoiceHeader);

</script>